
import { Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NavParams } from 'ionic-angular';

@Component({
    selector: 'test-lineup',
    templateUrl: 'test-lineup.html',
    encapsulation: ViewEncapsulation.None
})
export class LineTestPage {
   context: any;

   constructor(
    private navParams: NavParams,
    public sanitizer: DomSanitizer
    ){
    this.context = this.navParams.get('context');
   }
}




// WEBPACK FOOTER //
// /src/pages/apps/lineup/testpage/test-lineup.ts